module.exports = __webpack_public_path__ + "static/media/cloudedbanners_sm1.30cc4463.png";